import { Commands } from "../../../../vendor_core/core/src/commands/CommandEnum";
import CommandManager from "../../../../vendor_core/core/src/commands/CommandManager";
import { UpdateBalanceCommand } from "../../../../vendor_core/core/src/commands/GameCommands";
import PointerEvents from "../../../../vendor_core/core/src/const/PointerEvents";
import SoundVars from "../../../../vendor_core/core/src/const/SoundVars";
import BetModel from "../../../../vendor_core/core/src/model/BetModel";
import BuyFeatureModel from "../../../../vendor_core/core/src/model/BuyFeatureModel";
import { UIComponents } from "../../../../vendor_core/core/src/ui/UIComponents";
import AbstractPopup from "../../../../vendor_core/core/src/ui/popups/AbstractPopup";
import KeyboardManager from "../../../../vendor_core/core/src/utils/KeyboardManager";
import { DefaultLayers } from "../../../../vendor_core/core/src/utils/Layers";
import SoundController from "../../../../vendor_core/core/src/utils/SoundController";
import ViewManager from "../../../../vendor_core/core/src/utils/ViewManager";
import { MoneyField } from "../../../../vendor_core/core/src/views/MoneyField";
import SceneView from "../../../../vendor_core/core/src/views/SceneView";
import Button from "../../../../vendor_core/core/src/views/components/Button";
import TextField from "../../../../vendor_core/core/src/views/components/TextField";
import { VendorCommandsEnum } from "../../../../vendor_core/src/commands/VendorCommandsEnum";
import Configs from "../../../../vendor_core/src/vendorConfigs/Configs";


export default class BuyBonusPopups extends AbstractPopup {

    public closeBtn: Button;
    public buyBtnBN1: Button;
    public buyBtnBN2: Button;
    public betField: MoneyField;
    public totalPriceFieldBN1: MoneyField;
    public totalPriceFieldBN2: MoneyField;
    private confirmPrice: MoneyField;
    public animScene: SceneView;
    public plusBtn: Button;
    public minusBtn: Button;
    private acceptBtn: Button;
    private declineBtn: Button;

    constructor() {
        super();
        this.layer = ViewManager.getLayer(DefaultLayers.Popups);
    }

    public show(callback?: Function) {

        KeyboardManager.disable();
        this.hidden = false;
        this.scene = this.layer.setScene('futurebuy');
        this.scene.groups.get("fbc").visible = false;
        // prevent execute behind buttons events !
        this.scene.interactive = true;
        // this.animScene = ViewManager.getLayer("BuyFeaturePopup").setScene("open");
        this.closeBtn = this.scene.buttons.get("cancel") as Button;
        this.betField = this.scene.sceneMoneyFields.get('amount') as MoneyField;
        this.plusBtn = this.scene.buttons.get("plus") as Button;
        this.minusBtn = this.scene.buttons.get("minus") as Button;

        this.buyBtnBN1 = this.scene.buttons.get("bonus1") as Button;
        this.totalPriceFieldBN1 = this.scene.sceneMoneyFields.get('total_amount_bn1') as MoneyField;

        this.buyBtnBN2 = this.scene.buttons.get("bonus2") as Button;
        this.totalPriceFieldBN2 = this.scene.sceneMoneyFields.get('total_amount_bn2') as MoneyField;

        this.acceptBtn = this.scene.buttons.get("accept") as Button;
        this.declineBtn = this.scene.buttons.get("decline") as Button;
        this.confirmPrice = this.scene.sceneMoneyFields.get("confirmPrice") as MoneyField;


        this.setBetOptions();
        this.setBet();
        this.betSync();
        this.disableBetOptions();
        this.setTotalPrice();
        this.setInteractionOnPlus();
        this.setInteractionOnMinus();
        this.setInteractionOnBuyBN1();
        this.setInteractionOnBuyBN2();
        this.setInteractionOnAccept();
        this.setInteractionOnDecline();
        this.setInteractionOnClose(callback);

        ViewManager.getLayer(DefaultLayers.SplashOverlay).setScene("open");
    }

    protected setBetOptions() {
        /*
        slice all valid bets to bets witch we displayed on the Bet Settings example case 12
        */
        let bfConfig = Configs.buyFeature;
        let betConfig = Configs.bet;

        if (bfConfig.betOptions.length > 0) {
            BuyFeatureModel.validBets = bfConfig.getBetOptions();
        } else if (betConfig.betOptions.length > 0) {
            BuyFeatureModel.validBets = betConfig.getBetOptions();
        } else {
            BuyFeatureModel.validBets = [...BetModel.creditValues];
        }

        BuyFeatureModel.currentBetIndex = BuyFeatureModel.validBets.indexOf(BetModel.totalBet);
    }

    protected setBet() {
        const config = Configs.buyFeature;
        let bet = BuyFeatureModel.validBets[BuyFeatureModel.currentBetIndex];

        if (config.maxFeaturePurchasePrice &&
            bet * config.betMultiplier[BuyFeatureModel.mode] > config.maxFeaturePurchasePrice
        ) {
            for(let i = BuyFeatureModel.validBets.length -1; i >= 0; i--) {
                if (BuyFeatureModel.validBets[i] * config.betMultiplier[BuyFeatureModel.mode] <= config.maxFeaturePurchasePrice) {
                    bet = BuyFeatureModel.validBets[i];
                    BuyFeatureModel.currentBetIndex = i;
                    break;
                }
            }
        }

        if (bet) {
            this.betField.value = bet;
        }
    }

    protected betSync() {
        ViewManager.getLayer(DefaultLayers.BetBar)
            .setScene().sceneMoneyFields.get(UIComponents.TotalBetAlternative)
            .value = BuyFeatureModel.getBet();
    }

    protected disableBetOptions(): void {
        const config = Configs.buyFeature;

        this.plusBtn.setEnabled(true);
        this.minusBtn.setEnabled(true);

        if (BuyFeatureModel.currentBetIndex >= (BuyFeatureModel.validBets.length - 1) ||
            BuyFeatureModel.getTotalBet() >= config.maxFeaturePurchasePrice) {
            this.plusBtn.setEnabled(false);
        } if (BuyFeatureModel.currentBetIndex === 0) {
            this.minusBtn.setEnabled(false);
        }
    }

    protected setTotalPrice() {
        let config = Configs.buyFeature;
        let priceBN1 = this.betField.value * config.betMultiplier[0];
        let priceBN2 = this.betField.value * config.betMultiplier[1];
        this.totalPriceFieldBN1.value = priceBN1;
        this.totalPriceFieldBN2.value = priceBN2;
        this.checkBalanceEnoughForBuy(priceBN1, this.buyBtnBN1);
        this.checkBalanceEnoughForBuy(priceBN2, this.buyBtnBN2);
    }

    protected checkBalanceEnoughForBuy(price: number, buyBtn: Button) {
        if (BetModel.balance - price >= 0 && price <= Configs.buyFeature.maxFeaturePurchasePrice) {
            buyBtn.setEnabled(true);
        } else {
            buyBtn.setEnabled(false);
        }
    }

    protected setInteractionOnPlus() {
        this.plusBtn.on(PointerEvents.DOWN, () => {
            SoundController.playSound(SoundVars.BUTTON_CLICK)
            this.incrementBet();
            this.disableBetOptions();
        })
    }

    protected incrementBet() {
        if (BuyFeatureModel.currentBetIndex < (BuyFeatureModel.validBets.length - 1)) {
            BuyFeatureModel.currentBetIndex += 1;
            this.setBet();
            this.setTotalPrice();
            this.betSync();
        }
    }

    protected setInteractionOnMinus() {
        this.minusBtn.on(PointerEvents.DOWN, () => {
            SoundController.playSound(SoundVars.BUTTON_CLICK)
            this.decrementBet();
            this.disableBetOptions();
        })
    }

    protected decrementBet() {
        if (BuyFeatureModel.currentBetIndex > 0) {
            BuyFeatureModel.currentBetIndex -= 1;
            this.setBet();
            this.setTotalPrice();
            this.betSync();
        }
    }

    protected setInteractionOnClose(callback?: Function) {
        this.closeBtn.on(PointerEvents.DOWN, (e) => {
            e.stopPropagation();
            SoundController.playSound(SoundVars.BUTTON_CLICK);

            ViewManager.getLayer(DefaultLayers.BetBar)
            .setScene().sceneMoneyFields.get(UIComponents.TotalBetAlternative)
            .value = BetModel.totalBet;

            ViewManager.getLayer(DefaultLayers.SplashOverlay).completeClear();
            KeyboardManager.enable();
            this.hide();
        });
    }

    protected setInteractionOnBuyBN1() {
        this.buyBtnBN1.on(PointerEvents.DOWN, () => {
            BuyFeatureModel.mode = 0;
            this.confirmPrice.value = this.totalPriceFieldBN1.value;
            this.scene.groups.get("fb").visible = false;
            this.scene.groups.get("fbc").visible = true;
        });
    }

    protected setInteractionOnBuyBN2() {
        this.buyBtnBN2.on(PointerEvents.DOWN, () => {
            BuyFeatureModel.mode = 1;
            this.confirmPrice.value = this.totalPriceFieldBN2.value;
            this.scene.groups.get("fb").visible = false;
            this.scene.groups.get("fbc").visible = true;
        });
    }

    protected setInteractionOnAccept() {
        this.acceptBtn.once(PointerEvents.DOWN, () => {
            BuyFeatureModel.hasBuyFeatureIsTriggered = true;
            // BN1 = "betMode": 1
            // BN2 = "betMode": 2
            // that's why is +1
            BuyFeatureModel.extraParams = [
                { "betMode": BuyFeatureModel.mode +1 }
            ]
            this.onSelectionConfirmed();
        });
    }

    protected setInteractionOnDecline() {
        this.declineBtn.on(PointerEvents.DOWN, () => {
            BuyFeatureModel.extraParams = [];
            BuyFeatureModel.hasBuyFeatureIsTriggered = false;
            this.scene.groups.get("fb").visible = true;
            this.scene.groups.get("fbc").visible = false;
        });
    }

    protected onSelectionConfirmed() {
        // let config = Configs.buyFeature;
        // BetModel.balance -= config.betMultiplier[BuyFeatureModel.mode]  * BuyFeatureModel.validBets[BuyFeatureModel.currentBetIndex];
        // CommandManager.execute(VendorCommandsEnum.BALANCE_UPDATE, BetModel.balance);
        // UpdateBalanceCommand();
        const bfBet = BuyFeatureModel.getBet();
        // const bfTotalBet = BuyFeatureModel.getTotalBet();
        // let ss = BetModel.creditValues.indexOf(bfBet);

        CommandManager.execute(Commands.SET_BET, {
            coinIndex: BetModel.creditValues.indexOf(bfBet),
            multiplier: undefined,
            value: bfBet
        });

        CommandManager.execute(Commands.FEATURE_BUY_SPIN);

        this.declineBtn.off(PointerEvents.DOWN);
        this.buyBtnBN1.off(PointerEvents.DOWN);
        this.buyBtnBN2.off(PointerEvents.DOWN);

        ViewManager.getLayer(DefaultLayers.SplashOverlay).completeClear();
        this.hide();
    }

}
